import React, { useCallback, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import Sidebar from './Layouts/Sidebar'
import PerformanceScatterplot from './components/PerformanceScatterplot'
import RegisterPage from './components/register/RegisterPage'
import RegisterSuccess from './components/register/RegisterSuccess'
import RootContext from './libs/contexts/rootContext'

import CreatePasswordScreen from './screens/CreatePasswordScreen'
import DashboardScreen from './screens/DashboardScreen'
import ForgotPasswordScreen from './screens/ForgotPasswordScreen'
import LandingPageScreen from './screens/LandingPageScreen'
import LoginPageScreen from './screens/LoginPageScreen'
import ScorecardScreen from './screens/ScorecardScreen'
import { useMediaQuery } from '@mui/material';
import { Box } from '@mui/material'
import Navbar from './Layouts/Navbar'
import ApplicationManagement from './components/table/ApplicationManagementPage'
import './theme/App.css'
import DynamicView from './components/DynamicView'
import LoginPageV2 from './components/authUI/LoginPageV2'
import ProtectedDynamicView from './components/ProtectedDynamicView'
import DashboardV2 from './components/DashboardV2'
import RegisterPageV2 from './components/register/RegisterPageV2'
import LandingPageV2 from './components/LandingPageV2'
import ApplicationManagementV2 from './components/table/ApplicationManagementPageV2'
import { QueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import RegisterPageV3 from './components/register/RegisterPageV3'
import LoginPageV3 from './components/authUI/LoginPageV3'
import LandingPageV3 from './components/LandingPageV3'
import ApplicationManagementV3 from './components/table/ApplicationManagementPageV3'
import ProducerProfile from './components/ProducerProfile'
import Commissions from './components/Commissions'
import ProductInformation from './components/ProductInformation'


function App() {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const [drawerOpen, setDrawerOpen] = useState(isSmallScreen ? false : true)

  const queryClient = new QueryClient()

  // Function to save the cache
  function saveQueryData() {
    const queryData = queryClient.getQueryCache().getAll()
    localStorage.setItem('queryCache', JSON.stringify(queryData))
  }

  // Function to restore the cache
  function restoreQueryData() {
    const queryData = localStorage.getItem('queryCache')
    console.log('queryData', queryData)
    if (queryData) {
      const queries = JSON.parse(queryData)
      queries.forEach((query) => {
        queryClient.getQueryCache().build(queryClient, query)
      })
    }
  }
  useEffect(() => {
    // Restore on app start
    restoreQueryData()

    // Optionally, save periodically or on specific events
    window.addEventListener('beforeunload', saveQueryData)

    return () => {
      window.removeEventListener('beforeunload', saveQueryData)
    }
  }, [])

  const toggleDrawer = useCallback(
    (val) => {
      setDrawerOpen(val)
    },
    [setDrawerOpen]
  )

  return (
    <RootContext>
      <Box className="App" sx={{ display: 'flex', position: 'relative' }}>
        <Navbar drawerOpen={drawerOpen} toggleDrawer={setDrawerOpen} />
        <Sidebar open={drawerOpen} toggleDrawer={setDrawerOpen} />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: (theme) => theme.spacing(0),
            ...(drawerOpen && {
              transition: (theme) =>
                theme.transitions.create('margin', {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.leavingScreen,
                }),
            }),
            width: isSmallScreen
              ? `calc(100% - ${drawerOpen ? 270 : 0}px)`
              : `calc(100% - ${drawerOpen ? 270 : 100}px)`,
          }}
        >
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedDynamicView
                  version1={<LandingPageScreen />}
                  version2={<LandingPageV2 />}
                  version3={<LandingPageV3 />}
                />
              }
            />
            <Route
              path="/login"
              element={
                <DynamicView version1={<LoginPageScreen />} version2={<LoginPageV2 />} version3={<LoginPageV3 />} />
              }
            />
            <Route
              path="/register"
              element={
                <DynamicView version1={<RegisterPage />} version2={<RegisterPageV2 />} version3={<RegisterPageV3 />} />
              }
            />
            <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
            <Route
              path="/application-management"
              element={
                <ProtectedDynamicView
                  version1={<ApplicationManagement />}
                  version2={<ApplicationManagementV2 />}
                  version3={<ApplicationManagementV3 />}
                  isAppMngmt={true}
                />
              }
            />
            <Route
              path="/commissions"
              element={<ProtectedDynamicView version1={<></>} version2={<></>} version3={<Commissions />} />}
            />
            <Route
              path="/productInformation"
              element={<ProtectedDynamicView version1={<></>} version2={<></>} version3={<ProductInformation />} />}
            />
            <Route
              path="/profile"
              element={<ProtectedDynamicView version1={<></>} version2={<></>} version3={<ProducerProfile />} />}
            />

            {/* <Route
              path="/application-management"
              element={<ProtectedDynamicView version1={<ApplicationManagement />} version2={<></>} />}
            /> */}
            <Route path="/create-password" element={<CreatePasswordScreen />} />
            <Route path="/scatter" element={<PerformanceScatterplot />} />
            <Route
              path="/dashboard"
              element={<ProtectedDynamicView version1={<DashboardScreen />} version2={<DashboardV2 />} />}
            />
            <Route path="/scorecard" element={<ScorecardScreen />} />
            <Route path="/success" element={<RegisterSuccess />} />
          </Routes>
        </Box>
      </Box>
    </RootContext>
  )
}

export default App
